import React, { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import RestoreButton from "./RestoreButton";
import Card from "./Card";

function App() {
  const [daysLeft, setDaysLeft] = useState(0);
  const [daystoNextSunday, setDaysToNextSunday] = useState(0);
  const [isSundayAvailable, setIsSundayAvailable] = useState(true);
  const [nextSalaryDate, setNextSalaryDate] = useState(null);

  // Private
  const dailyBudget = 200;
  const monthlyTotalBudget = daysLeft * dailyBudget;
  const monthlyBuffertBudget = monthlyTotalBudget - dailyBudget;

  const dailyCommonBudget = 200;
  const weeklyCommonBudget = isSundayAvailable
    ? daystoNextSunday * dailyCommonBudget
    : daysLeft * dailyCommonBudget;

  const monthlyCommonBuffertBudget = isSundayAvailable
    ? (daysLeft - daystoNextSunday) * dailyCommonBudget
    : 0;

  const calculateDaysToNextSunday = useCallback(() => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysUntilSunday = (7 - dayOfWeek) % 7;
    const daysToNextSunday = daysUntilSunday === 0 ? 7 : daysUntilSunday;

    setDaysToNextSunday(daysToNextSunday);
    checkIfSundayAvailable(today, daysUntilSunday);
  }, []);

  function checkIfSundayAvailable(today, daysUntilSunday) {
    const savedDate = Cookies.get("nextSalaryDate");
    if (savedDate) {
      const salaryDate = new Date(savedDate);
      const daysBetween = Math.ceil(
        (salaryDate - today) / (1000 * 60 * 60 * 24)
      );

      if (daysBetween <= daysUntilSunday) {
        setIsSundayAvailable(false);
      } else {
        setIsSundayAvailable(true);
      }
    }
  }

  function formatNumber(number) {
    return new Intl.NumberFormat().format(number);
  }

  const calculateDaysLeft = useCallback((salaryDate) => {
    const today = new Date();
    const timeDiff = salaryDate - today;
    const days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    setDaysLeft(days > 0 ? days : 0);
  }, []);

  const askForNextSalaryDate = useCallback(() => {
    Swal.fire({
      title: "Ange dag för nästa lön",
      input: "text",
      inputPlaceholder: new Date().toISOString().slice(0, 10),
      showCancelButton: true,
      confirmButtonText: "Spara datum",
      cancelButtonText: "Stäng",
    }).then((result) => {
      if (result.isConfirmed) {
        const enteredDate = result.value;
        const salaryDate = new Date(enteredDate);
        if (!isNaN(salaryDate) && salaryDate > new Date()) {
          calculateDaysLeft(salaryDate); // Safe to use now
          setNextSalaryDate(enteredDate);
          Cookies.set("nextSalaryDate", enteredDate, { expires: 30 });
        } else {
          Swal.fire(
            "Felaktigt datum",
            "Vänligen ange ett datum enligt ÅÅÅÅ-MM-DD",
            "error"
          );
        }
      }
    });
  }, [calculateDaysLeft]);

  function askForResetNextSalaryDate() {
    Swal.fire({
      title: "Är du säker?",
      showCancelButton: true,
      confirmButtonText: "Ja, återställ datum",
      cancelButtonText: "Stäng",
    }).then((result) => {
      if (result.isConfirmed) {
        setNextSalaryDate(null);
        Cookies.remove("nextSalaryDate");
        window.location.reload();
      }
    });
  }

  useEffect(() => {
    const savedDate = Cookies.get("nextSalaryDate");
    if (savedDate) {
      calculateDaysLeft(new Date(savedDate));
      calculateDaysToNextSunday();
      setNextSalaryDate(savedDate);
    } else {
      askForNextSalaryDate();
    }
  }, [askForNextSalaryDate, calculateDaysToNextSunday, calculateDaysLeft]);

  return (
    <>
      {daysLeft === 0 ? (
        <div className="grid grid-cols-6 gap-4 p-4 md:p-12 w-full">
          <Card
            title={"Data saknas"}
            content={
              "För att använda de här funktionerna måste du ange ett datum."
            }
          />
          <div className="d-flex justify-content-center">
            <RestoreButton askForResetNextSalaryDate={askForNextSalaryDate} />
          </div>
        </div>
      ) : (
        <>
          <h1 className="text-center mt-3">Privat budget</h1>
          <Card
            title={formatNumber(daysLeft) + " dagar"}
            content={`Dagar till lön (${
              nextSalaryDate ? nextSalaryDate : "Ej angivet"
            })`}
          />
          <Card
            title={formatNumber(monthlyBuffertBudget) + " SEK"}
            content={"Mellanlandning"}
          />
          <h1 className="text-center">Gemensam budget</h1>
          <Card
            title={"~" + formatNumber(weeklyCommonBudget) + " SEK"}
            content={"Veckobudget"}
          />
          <Card
            title={formatNumber(monthlyCommonBuffertBudget) + " SEK"}
            content={"Månadsbuffert"}
          />
          <div className="fixed-bottom d-flex justify-content-center text-center">
            <RestoreButton
              askForResetNextSalaryDate={askForResetNextSalaryDate}
            />
          </div>
        </>
      )}
    </>
  );
}

export default App;
